window.dataLayer = window.dataLayer || [];
window.AVADA_COOKIES_BAR = window.AVADA_COOKIES_BAR || {};
function gtag() {window.dataLayer.push(arguments)}
function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return JSON.parse(decodeURIComponent(c.substring(nameEQ.length, c.length)));
    }
    return {};
  }
window.AVADA_COOKIE_CONSENT = getCookie('avada_cookie_consent');
